<template>
  <pt-promotion-coupon class="pt-promotion-coupon__page"></pt-promotion-coupon>
</template>

<script>
import PtPromotionCoupon from 'cps/mall-manage/pt-promotion-coupon/withData'
export default {
  name: 'pt-promotion-coupon__view',
  components: {
    'pt-promotion-coupon': PtPromotionCoupon
  }
}
</script>
